import React, { useContext, useState } from "react";
import { PitchContext } from "../context/PitchContex";
import axios from "axios";
import AccessDenied from "../components/AccessDenied";

const AddTeam = () => {
  const [previewUrl, setPreviewUrl] = useState();
  const [image, setImage] = useState(null);

  const {
    user,
    token,
    backendURL,
    setAlertMessage,
    setShowAlert,
    setIsErr,
    setPending,
    navigate,
  } = useContext(PitchContext);

  const [teamData, setTeamData] = useState({
    name: "",
    slug: "",
    captain: user._id,
    description: "",
    city: "",
    players: [user.playerProfile.profile[0]._id],
  });

  const generateSlug = (name) => {
    return name
      .toLowerCase()
      .replace(/\s+/g, "-") // Replace spaces with -
      .replace(/[^\w-]/g, "") // Remove special characters
      .substring(0, 50); // Limit length
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setTeamData((prevData) => ({
      ...prevData,
      [name]: value,
      ...(name === "name" && { slug: generateSlug(value) }), // Auto-generate slug
    }));
  };

  const handleImageChange = (e) => {
    const selectedImage = e.target.files[0];
    setImage(selectedImage);
    if (selectedImage) {
      setPreviewUrl(URL.createObjectURL(selectedImage));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setPending(true);
    try {
      const formData = new FormData();

      // Append all key-value pairs from newData to FormData
      Object.entries(teamData).forEach(([key, value]) => {
        formData.append(key, value);
      });

      if (image) {
        formData.append("image", image);
      }
      const response = await axios.post(backendURL + "team/create", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      console.log(response);
      if (response.data.success) {
        setPending(false);
        setAlertMessage(response.data.message);
        setIsErr(false);
        setShowAlert(true);
        navigate("/");
      } else {
        setPending(false);
        setAlertMessage(response.data.message);
        setIsErr(true);
        setShowAlert(true);
      }
    } catch (err) {
      console.log(err);
      setPending(false);
      setAlertMessage(err.response.data.message);
      setIsErr(true);
      setShowAlert(true);
    }
    console.log("New Team Data:", teamData);
  };

  if (!token) {
    return <AccessDenied />;
  }
  if (user.team) {
    return <AccessDenied />;
  }

  return (
    <div className="bg-gray-100 min-h-screen flex items-center justify-center p-6">
      <div className="bg-white p-8 shadow-lg rounded-xl w-full max-w-2xl">
        <h2 className="text-3xl font-bold text-center mb-6">Yeni Takım Ekle</h2>
        <div className="flex flex-col items-center">
          <label htmlFor="singleImage" className="cursor-pointer group mb-4">
            <div className="w-32 h-32 bg-gray-100 rounded-full overflow-hidden flex items-center justify-center border-2 border-dashed border-gray-300 group-hover:border-[#6ca87e] transition-all duration-200">
              <img
                className="w-full h-full object-cover"
                src={
                  previewUrl || image
                    ? previewUrl || URL.createObjectURL(image)
                    : "https://upload.wikimedia.org/wikipedia/commons/7/7c/Profile_avatar_placeholder_large.png?20150327203541"
                }
                alt="Profile Preview"
              />
            </div>
            <input
              onChange={handleImageChange}
              type="file"
              id="singleImage"
              accept="image/*"
              hidden
            />
          </label>
          <span className="text-gray-600 text-sm">
            Takım fotoğrafı eklemek için tıkla
          </span>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block font-semibold mb-2">Takım İsmi</label>
            <input
              type="text"
              name="name"
              value={teamData.name}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-lg"
              required
            />
          </div>

          {/* Slug Input Field */}
          <div>
            <label className="block font-semibold mb-2">Benzersiz Ad</label>
            <input
              type="text"
              name="slug"
              value={teamData.slug}
              readOnly
              className="w-full px-4 py-2 border rounded-lg bg-gray-200 cursor-not-allowed"
            />
            <small className="text-gray-500">
              Takım ismine göre otomatik oluşturulacaktır.
            </small>
          </div>

          <div>
            <label className="block font-semibold mb-2">Açıklama</label>
            <textarea
              name="description"
              value={teamData.description}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-lg"
              rows="4"
            />
          </div>
          <div>
            <label className="block font-semibold mb-2">Şehir</label>
            <input
              type="text"
              name="city"
              value={teamData.city}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-lg"
              required
            />
          </div>

          <div>
            <button
              type="submit"
              className="w-full bg-[#4d9041] text-white py-2 rounded-lg font-semibold hover:bg-[#62a556] cursor-pointer"
            >
              Ekle
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddTeam;
